import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://hmdjptoujrbtcrashiwj.supabase.co";
const supabasePublishableKey = "sb_publishable_pgMXaLr-sBL71wn42v2giA_ya-iDyX0";

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
});

